import ListViewCtrl from "../util/ListViewCtrl";
import { Worker } from "../util";

export default class OdberneMiestoImportCtrl {

  constructor(OdberneMiestoService){
    this.OdberneMiestoService = OdberneMiestoService;
    this.file = null;
    this.batch = [];
    this.importXls = Worker(this._importXls);
    this.confirm = Worker(this._confirm);
    this.createXMLBilancnaSkupina = Worker(this._createXMLBilancnaSkupina);
    this.platnostOd = null;
    this.platnostDo = null;
  }

  onFile($file){
    this.file = $file;
    console.log('File set');
  }

  exportXlsPlyn(){
    this.OdberneMiestoService.exportXlsPlyn();
  }

  _createXMLBilancnaSkupina() {
    console.log('Generujem poziadavku pre bilancnu skupinu');
    return this.OdberneMiestoService.createXMLBilancnaSkupina(this.platnostOd, this.platnostDo);
  }

  _importXls(){
    return this.OdberneMiestoService.readXlsPlyn(this.file)
      .then(batch => this.batch = batch)
      .then(() => this.file = null);
  }

  _confirm(){
    return this.OdberneMiestoService.batch(this.batch)
      .then(() => this.batch = []);
  }




}


// WEBPACK FOOTER //
// ./src/OdberneMiesto/OdberneMiestoImportCtrl.js